import { ReactComponent as AIProcessingIcon } from 'assets/images/ai/ai-processing.svg'
import './LoadingMessage.scss'

const LoadingMessage = () => {
  return (
    <div
      className="thanx-ai-typing-indicator"
      role="status"
      aria-live="polite"
      aria-label="Loading"
    >
      <AIProcessingIcon aria-hidden="true" />
    </div>
  )
}

export default LoadingMessage
